export default {
  okmain:{
    lang:"English",
    openkylinweburl:'https://www.openkylin.top/index-en.html',
    openkylinsigurl:'https://www.openkylin.top/sig/application-en.html',
    openkylinmemberurl:'https://www.openkylin.top/community/partner-en.html',
    nav1:"Overview",
    nav2:"Contribution",
    nav3:"Official Website",
    nav_sig: "SIG Contribution",
    nav_member: "Member Contribution",
    nav_number: "Personal Contribution",
    user:"Users",
    deploy: "Deployments",
    contributors:"Contributors",
    member:"Members",
    sig:"SIG",
    repositories:"Repositories",
    commits:"Commits",
    pr:"PR",
    issues:"Issues",
    code_lines: "Code Lines",
    f_copyright:"Copyright@openKylin 2026 ICP No. 2020036654-21 Beijing",
    f_garight:"No.11030102011760",
    f_code:"Gitee",
    f_joinmember:"Join Member",
    f_joinsig:"Join SIG",
    f_updatetime:"Update Time",
    f_frequency:"Frequency",
    f_times:"hours 1 time",
    c_devel_contribute:"Developer Contributions",
    c_member_contribute:"Members Contributions",
    c_sig_contribute:"SIG Contributions",
    c_time1:'Last Month',
    c_time2:'Past Half Year',
    c_time3:'Last Year',
    c_all:'All',
    c_metrics:'Metrics',
    c_time: "Time Length",
    c_points:'Points',
    c_range:'Display Range',
    c_sort:'#',
    // Sorting
    c_giteename:"Gitee Name",
    c_membername:"Member Name",
    c_signame:"SIG Name",
    c_communityname:"Community Name",
    c_contributionvalue:"Contribution Value",
    c_pointvalue:"Point Value",
  }
};



// WEBPACK FOOTER //
// ./src/local/language/en.js